module.exports = __webpack_public_path__ + "img/thank-img-hover.e317e3f0.png";